"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M22 22H2v-2h20zM10 2H7v16h3zm7 6h-3v10h3z"
}), 'AlignVerticalBottomOutlined');